import { render, staticRenderFns } from "./PrioridadeModal.vue?vue&type=template&id=df70521c&scoped=true"
import script from "./PrioridadeModal.vue?vue&type=script&lang=js"
export * from "./PrioridadeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df70521c",
  null
  
)

export default component.exports